// Development-only, bounded and deliberately excludes payloads, credentials and cursors.
const entries = [];
export function recordMessagingRecovery(stage, { trigger, connected, conversationId } = {}) {
  if (process.env.NODE_ENV !== "development") return;
  const entry = { at: new Date().toISOString(), stage, trigger, connected, conversationId };
  entries.push(entry);
  if (entries.length > 40) entries.shift();
  console.debug("[Messaging recovery]", entry);
}
export function getMessagingRecoveryDiagnostics() {
  return entries.map(entry => ({ ...entry }));
}
